'use client';

import './DatePicker.scss';

import SvgChevronleft from '@common/__generated__/icon/components/SvgChevronleft';
import SvgChevronright from '@common/__generated__/icon/components/SvgChevronright';
import SvgChevronrightDouble from '@common/__generated__/icon/components/SvgChevronrightDouble';
import SvgChevronrleftDouble from '@common/__generated__/icon/components/SvgChevronrleftDouble';
import { cn } from '@common/utils';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@radix-ui/react-popover';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { Calendar } from 'react-calendar';

interface DatePickerProps {
  /** YYYY-MM-DD */
  value: string | null;
  onChange: (date: string) => void;
  placeholder?: string;
  className?: string;
  /** YYYY-MM-DD */
  minDate?: string;
  /** YYYY-MM-DD */
  maxDate?: string;
}

export const DatePicker: React.FC<DatePickerProps> = ({
  value,
  onChange,
  placeholder,
  className,
  minDate,
  maxDate,
}) => {
  const [open, setOpen] = useState(false);

  const label = value ? dayjs(value).format('YYYY. MM. DD.') : null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          className={cn(
            'relative flex items-center border-1 border-Gray-300 bg-Gray-white text-Gray-900 outline-none transition-[border] duration-150 typo-body3',
            'h-48 w-200 min-w-fit rounded-small px-16',
            {
              'text-Gray-500': !value && placeholder,
            },
            className,
          )}
        >
          {value ? label : placeholder}
        </button>
      </PopoverTrigger>
      <PopoverContent>
        <div className="mt-8 max-w-300 rounded-small border-1 border-Gray-300 bg-Gray-white p-12">
          <Calendar
            className="common-date-picker"
            maxDate={maxDate ? new Date(maxDate) : undefined}
            minDate={minDate ? new Date(minDate) : undefined}
            next2Label={<SvgChevronrightDouble />}
            nextLabel={<SvgChevronright />}
            prev2Label={<SvgChevronrleftDouble />}
            prevLabel={<SvgChevronleft />}
            value={value?.toString()}
            onChange={(value: any) => {
              if (dayjs(value).isValid()) {
                onChange(dayjs(value).format('YYYY-MM-DD'));
                setOpen(false);
              }
            }}
          />
        </div>
      </PopoverContent>
    </Popover>
  );
};
